import { render } from "./App.vue?vue&type=template&id=16e28b02"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=16e28b02&lang=scss"

import exportComponent from "D:\\code\\csgj\\sjg-wine-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__